module.exports = __webpack_public_path__ + "img/Logo-Kurier-Color-Tribunal.502f5a27.png";